(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('QuestionAnswerController', QuestionAnswerController);

    QuestionAnswerController.$inject = ['QuestionAnswer'];

    function QuestionAnswerController(QuestionAnswer) {

        var vm = this;

        vm.questionAnswers = [];

        loadAll();

        function loadAll() {
            QuestionAnswer.query(function(result) {
                vm.questionAnswers = result;
                vm.searchQuery = null;
            });
        }
    }
})();
